$(function(){

    const dashboardMobileSelector = $('#dashboardMobile');

    if(dashboardMobileSelector.length){

        if (dashboardMobileSelector.parent('.iti').length === 0) {

            dashboardMobileSelector.intlTelInput(defaultIntlTelInput);

        }

    }

    $('#schoolRegisterForm').on('submit', function(e){
       e.preventDefault();

       const form = $(this);
       const formData = new FormData(this);
       const submitButton = form.find('button[type="submit"]');
       const formResponse = $('#formResponse');
       const mobileSelector = $('#dashboardMobile');

        formResponse.text('');
       submitButton.prop('disabled', true).text('wait...');
       formData.set('country_code', mobileSelector.intlTelInput("getSelectedCountryData").dialCode.replace('+', ''));

        if(formData.get('password') !== formData.get('confirm_password')){

            formResponse.addClass('text-danger').removeClass('text-success').text('Password Mismatched');
            submitButton.prop('disabled', false).text('Register');
            return false;

        }

       mainApiAxios.post('/dashboard/register-school', formData).then(res => {

           const responseData = res.data;
           $('#finalFormResponse').html(`${responseData.msg} <br> if didn't received email then, <a href="javascript:void(0)" class="btn btn-link text-primary font-weight-bold" onclick="requestSchoolVerificationEmail(event, ${responseData.user.id})">Request again!</a>`).addClass('text-success').removeClass('text-danger');
           form.remove();


       }).catch(err => {

           const responseData = err.response.data;
           formResponse.text(responseData.msg).removeClass('text-success').addClass('text-danger');
           submitButton.prop('disabled', false).text('Register');
           console.log(responseData);

       });


    });

    if(window.location.href.includes('verify-email')) verifyEmail();

});

window.verifyEmail = () => {
    const formResponse = $('#formResponse');
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get('key') ?? '';

    if(key.length === 0) return false;

    mainApiAxios.get(`/dashboard/verify-email?key=${urlParams.get('key')}`).then(res => {

        const responseData = res.data;
        formResponse.html(`${responseData.msg} <br> Please wait, redirecting to login page...`).addClass('text-success');
        dashboardLoginSuccess(res);

    }).catch(err => {

        const responseData = err.response.data;
        formResponse.text(responseData.msg).addClass('text-danger');

    });

}

window.requestSchoolVerificationEmail = (event, userId) => {

    const button = $(event.target);
    button.prop('disabled', true).text('wait...');

    mainApiAxios.post('/dashboard/school-verification-email', {user_id: userId}).then(res => {

        const responseData = res.data;
        button.prop('disabled', false).text('Request again');

    }).catch(err => {

        const responseDat = err.response.data;

        button.prop('disabled', false).text('Request again');

    });

}
